import React from 'react';
import { shape, string } from 'prop-types';
import styled from 'styled-components';

import getCurrentLanguageKey from 'Jsx/Utils/getCurrentLanguageKey';

const LOCALES = {
  es: { SEE_IMAGE: 'Ver imagen' },
  pt: { SEE_IMAGE: 'Ver imagem' },
};

const STRINGS = LOCALES[getCurrentLanguageKey()];

const Wrapper = styled.div`
  position: relative;
  width: fit-content;
  max-width: 100%;
  max-height: 200px;
  overflow: hidden;
  & .overlay {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    text-align: center;
    padding: 8px 0;
    background-image: linear-gradient(to top, #000000cc, #00000000);
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
  }
  &:hover .overlay {
    opacity: 1;
  }
`;

const Link = styled.a`
  display: block;
  width: fit-content;
`;

const Img = styled.img`
  width: auto;
  max-width: 100%;
  max-height: 200px;
`;

const Image = ({ src, href }) => {
  if (href) {
    return (
      <Link href={href} target="_blank" rel="noopener noreferrer">
        <Image alt="" src={src} />
      </Link>
    );
  }
  return (
    <Link href={src} target="_blank" rel="noopener noreferrer">
      <Wrapper>
        <Img alt="" src={src} />
        <div className="overlay font-subtitle3 text-white">
          {STRINGS.SEE_IMAGE}
        </div>
      </Wrapper>
    </Link>
  );
};

Image.propTypes = {
  src: string.isRequired,
  href: string,
};

Image.defaultProps = {
  href: null,
};

export default Image;
